

  <div class="signup-card">
    <span><h1>Verification code has been sent to email</h1></span>
<div class="header d-flex justify-content-between">
  
  <i class="fa fa-times cursor-pointer" aria-hidden="true" (click)="dissmissModal()"></i>
</div>

 <!-- <form [formGroup]="formGroup" class="form"> -->
  <form [formGroup]="signupFormConfirm"  class="signup-form">
    <div class="name-row">
    <div class="form-field"> 
      <div>
        <label for="subtitle">Confirm Code*</label>
        <input
          type="text"
          class="form-control"
          formControlName="inputField"
          placeholder="Enter Code" />
      </div> 
      
  </div>
</div>
<div *ngIf="timeLeft > 0">
  OTP Expired in {{ timeLeft }} seconds
</div>
<!-- <button type="button" [disabled]="isResendDisabled" (click)="resendOtp()">
  Resend OTP
</button> -->
<div style="text-align: center;">
  <button type="submit" [disabled]="isSubmitDisabled" class="btn btn-success" (click)="submit()">
  Submit
</button>
</div>
    </form>
    </div>
      <!-- <mat-form-field>
        <mat-label>Reports*</mat-label>
        <mat-select formControlName="dashboards" multiple>
          <mat-option
            *ngFor="let item of dashboardOptions"
            [value]="item.value"
            >{{ item.viewValue }}</mat-option
          >
        </mat-select>
      </mat-form-field> -->

      <!-- <div class="">
        <label for="site">Select Reports*</label>
        <ng-select
          [placeholder]="'Select Reports'"
          [multiple]="true"
          formControlName="dashboards"
          appendTo="body">
          <ng-option *ngFor="let item of dashboardOptions" [value]="item.value">
            {{ item.viewValue }}
          </ng-option>
        </ng-select>
      </div> -->

      <!-- <mat-form-field>
        <mat-label>Order*</mat-label>
        <mat-select formControlName="order">
          <mat-option *ngFor="let num of orderOptions" [value]="num">{{
            num
          }}</mat-option>
        </mat-select>
      </mat-form-field> -->


      <!-- <div class="">
        <label for="site">Order*</label>
        <ng-select
          [placeholder]="'Select order'"
          [multiple]="false"
          formControlName="order"
          appendTo="body">
          <ng-option *ngFor="let num of orderOptions" [value]="num">
            {{ num }}
          </ng-option>
        </ng-select>
      </div> 

      <span>
        <i
          *ngIf="formArray.controls.length > 1"
          class="fa fa-trash fa-lg"
          aria-hidden="true"
          (click)="removeFormGroup(i)"></i>
      </span>
    </div>
  </div>

  <div class="d-flex justify-content-between align-items-center my-2">
    <span class="cursor-pointer" (click)="addFormGroup()">
      <i
        class="fa fa-plus-circle fa-lg"
        aria-hidden="true"
        *ngIf="formArray.controls.length < 10"
        title="Add Link"></i>
      Add Link
    </span>
    <button type="submit" class="btn btn-success" (click)="submit()">
      Submit
    </button>
  </div>
</form> -->
